/* eslint-disable @wordpress/dependency-group */
import ScrollReveal from 'scrollreveal';

const nodeList = document.querySelectorAll('[rel="in-view"]'),
	team = document.querySelector('.team'),
	opportunities = document.querySelector('.opportunities');

const slideLeft = {
	delay: 2000,
	distance: '50px',
	duration: 1000,
	origin: 'left',
	opacity: null,
	useDelay: 'onload',
	reset: true,
	mobile: false,
};

const slideRight = {
	delay: 2000,
	distance: '50px',
	duration: 1000,
	origin: 'right',
	opacity: null,
	useDelay: 'onload',
	reset: true,
	mobile: false,
};

// Why: when a target column is already inside the initial viewport on
// first paint, attaching a ScrollReveal entrance animation (50px slide,
// 2s delay) can prevent Lighthouse from observing an LCP candidate during
// its measurement window. Above-the-fold sections add no UX value from
// an entrance animation — skip reveal() for any column already visible.
const isAboveTheFold = (el) => {
	const rect = el.getBoundingClientRect();
	const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
	return rect.top < viewportHeight && rect.bottom > 0;
};

Array.from(nodeList).forEach((item) => {
	const columns = item.querySelectorAll('.wp-block-column');
	if (columns.length === 2) {
		const reversed = item.classList.contains('lp-section-reverse');
		const targetA = reversed ? columns[1] : columns[0];
		const targetB = reversed ? columns[0] : columns[1];

		if (!isAboveTheFold(targetA)) {
			ScrollReveal().reveal(targetA, slideLeft);
		}
		if (!isAboveTheFold(targetB)) {
			ScrollReveal().reveal(targetB, slideRight);
		}
	}
});

if (team) {
	ScrollReveal().reveal('.member', {
		interval: 300,
		easing: 'ease-in-out',
		scale: 0.8,
		rotate: {
			z: -5,
		},
	});
}

if (opportunities) {
	ScrollReveal().reveal(opportunities, {
		afterReveal: (elem) => {
			elem.classList.add('opportunities-visible');
		},
	});
}
